//
// Global declarations
//
var CONFIG = {}; 
var DATA = {};

// constants for the map
// Min and Max map circle areas, in km2
CONFIG.circleareas = {
  min: 15000,
  max: 1300000,
}
CONFIG.map_height = 250; // map height in px
CONFIG.points;           // placeholder for lat-lng circles
CONFIG.circles;          // placeholder fo map circles
CONFIG.circleScale;      // scale for the map circles
CONFIG.minzoom= 1;       // max zoom for the map
CONFIG.maxzoom= 18;      // min zoom
// circle colors on map, for selected and unselected
var circlecolors = {
  "default": "#64b0e0",
  "selected": "#07395B",
}
CONFIG.defaultStyle  = {"fillColor": circlecolors["default"], "color": circlecolors["default"]};
CONFIG.selectedStyle = {"fillColor": circlecolors["selected"], "color": circlecolors["selected"]};

// placeholder for the selected row, used for row selections
CONFIG.selectedgroup = {};

// constants for the chart, squares, rows
CONFIG["offsets"] = {};
CONFIG["offsets"].sqsize       = 17;    // width and hight of chart squares
CONFIG["offsets"].rowpadding   = 15;    // padding between rows
CONFIG["offsets"].labelsize    = 13;    // size of text label size in pixels
CONFIG["offsets"].textwidth    = 210;   // width of the text label "column"
CONFIG["offsets"].textpadding  = 10;    // right side padding of text label
CONFIG["offsets"].toprowpad    = 20;    // padding around the top "summary" row in each column

// column colors: 
// first three colors are as-is from the existing strategies, the rest are frmo colorBrewer "Paired"
// see colorColumns(). This will support from 1-12 columns
CONFIG["col-colors"] = ["#42858C","#75396D","#BFB795","#33a02c","#fb9a99","#e31a1c","#fdbf6f","#ff7f00","#cab2d6","#6a3d9a","#ffff99","#b15928"];

///////////////////////////////////////////////////
// FUNCTIONS CALLED ON DOC READY 
///////////////////////////////////////////////////
$(document).ready(function($) { 
  // init functions
  initApp();
  initTooltips();
  initTour();
  initSelect();
  initScrollBehavior();
  initMisc();
});

///////////////////////////////////////////////////
// INIT FUNCTIONS 
///////////////////////////////////////////////////

// get a list of available strategies, check for params,
// and when all is well, kick off D3 
function initApp() {
  // get the list of all possible strategy id's
  $.get("./data/strategies/", function(strategies) {
    // check URL for a query param representing a path to data
    var params = new URLSearchParams(window.location.search);
    CONFIG.strategy = params.get("strategy");
    // if we get an invalid param, pretend like nothing happened:
    if ( (strategies.indexOf(+CONFIG.strategy) < 0) || typeof CONFIG.strategy === "undefined" ) CONFIG.strategy = "1"; 
    
    // check URL for an embed param
    if (params.has('embed') && params.get('embed') == "true") {
      // if present, hide the navbar, and hide publications
      $("nav").hide();
      $("div#top-card").css("margin-top", "-70px");
      $("div.publications-wrapper").hide();
      // show a link to "Get Involved", and have it open a new window
      $("div.embed-show#get-involved-button").show().find("a").attr("target", "_blank");
    };

    // now init D3, using CONFIG.strategy to know what data to get
    initD3();
  });
}

// tooltip inits
function initTooltips() {
  // define a global ref to the tooltips
  CONFIG.tooltip = d3.select("div.square-tooltip");
  CONFIG.tooltip.call(d3.drag().on("drag", drag));

  // and tooltip drag behavior
  function drag(d) {
    if (isMobile()) return;
    CONFIG.tooltip_dragged = true;
    var tip = d3.select(this);
    var top = parseInt(tip.style("top"));
    var left = parseInt(tip.style("left"));
    var dy = top + d3.event.dy + "px";  
    var dx = left + d3.event.dx + "px";
    d3.select(this).style("top", dy).style("left", dx);
  }
  // track whether we've dragged a tooltip or not
  CONFIG.tooltip_dragged = false;
  // and tooltip close button
  CONFIG.tooltip.select("span.tooltip-close")
    .on("click", function() { clearSquares(); closeSquareTooltip() });  
}

// an intro.js tour, triggered by a button in the nav that is visible only on the datavis pages
// intro.js doesn't work well with SVG, and most of the markup is created at run time, so we just manually create them when the tour starts
function initTour() {
  $("button#launch-tour").show().on("click", function() {
    let steps = []; 

    // step 1
    steps.push({
      element: document.getElementById("map"),
      intro: "Bigger bubble means there is more scientific evidence for this country on this platform. If you click on a bubble, only squares representing evidence from that country will show in the ‘more detail’ view below."
    });

    // step 2
    steps.push({
      element: document.getElementById("legend-container"),
      intro: "A green square stands for evidence that the conservation strategy was associated with a positive outcome (something good happened). A yellow square means a neutral outcomes (nothing much happened), and a red square means a negative outcome (things got even worse than without conservation). <b>Warning</b>: one red square doesn’t cancel out a green square! Individual squares often don’t have the same weight!"
    });

    // step 3
    // this one is the problem. Doesn't work quite right on SVG, so create a div to sit atop that SVG, and tag it with the tour
    // then remove it when the tour is over
    let rect = $("svg rect")[0];
    var x = rect.getAttribute("x");
    var y = rect.getAttribute("y");
    var width = rect.getAttribute("width");
    var height = rect.getAttribute("height");
    // create the div with the same position and size as the rect
    var parent = rect.parentNode.parentNode;
    var div = document.createElement("div");
    div.style.position = "absolute";
    div.style.width = width + "px";
    div.style.height = height + "px";
    div.style.top = y + "px";
    div.style.left = x + "px";
    div.style.background = "#52BF58";
    div.setAttribute("class","square tour-square");
    div.setAttribute("data-intro","hiya hiay hia");
    parent.appendChild(div);
    steps.push({
      element: div,
      intro: "Click on a square to see what a study found, and for a link to the original publication. One publication can be represented by several squares, for example one study could investigate conservation outcomes in two countries.",
    });

    // step 3
    steps.push({
      element: document.querySelector("div.textwrapper div.text span.variable-text"),
      intro: "The evidence is sorted by detailed categories. If you want to see evidence for one category on a map, like 'Animal Diversity', click the category name. To clear, click the category name a second time, or click the clear button at the bottom left of the map to go back to default view.",
    });

    // step 4
    steps.push({
      element: document.querySelector("div.filter-evidence span.select2.select2-container"),
      intro: "Not all evidence is equal. Evidence from more robust studies is shown by darker colours, but here you can display one <a href='https://www.sciencedirect.com/science/article/abs/pii/S0169534719300825' target='_blank'>evidence strength category</a> at a time."
    });

    // step 5: not attached to an element, but a gneral message, so append to main(?)
    steps.push({
      element: document.getElementById("main-container"),
      intro: "This database is being continuously updated by a community of volunteers, but it should not be considered exhaustive. Do you know of evidence that is missing? <a href='../getinvolved'>Help us add it!</a>"
    })

    // All set! Now start introJS with those steps, and end with a callback onexit to remove the div
    introJs().addSteps(steps).start().onexit(function() {
      // get rid of the "fake" square we added above, so it doesn't interfere with anything
      $("div.square.tour-square").remove();
    });
  });
}

function initSelect() {
  // any select option change should clear squares and tooltips
  $('select').on("change", function() { clearSquares(); closeSquareTooltip(); })
}

function initScrollBehavior() {
  // listen for scroll, and close legend tooltips (only mobile)
  $(document).on("scroll", function() {
    if (isMobile()) setTimeout(function() { closeLegendTooltip(); closeVariableInfoTip(); },500);
  } );
}

function initMisc() {
  if ( isMobile() ) $("div.toggler").click();            // init the show/hide detail panels for mobile
  CONFIG.cachedwidth = $(window).width()                 // set a constant to keep track of our width, see resizeContainers()
  $(window).on("resize", _.debounce(resizePage, 350));   // set a window resize callback
}

//
// D3 initiation: data queue, dispatch events
//

function initD3() {
  // register events to emit & listen for via d3 dispatch
  CONFIG.dispatch = d3.dispatch("load", "leaflet", "statechange");
  initD3DispatchFunctions();

  // get data and a callback when download is complete
  d3.queue()
    .defer(d3.json, `./data/findings/${CONFIG.strategy}`)  // primary data file
    .defer(d3.json, `./data/lookups/${CONFIG.strategy}`)   // data and various other "lookups"
    .await(main);
}

// callback from d3.queue()
function main(error, data, lookups) {
  if (error) throw error;

  // Keep global references to raw data
  DATA.rawdata = data;
  DATA.lookup = lookups;

  // Pre-processing of data, several tasks
  // 1) get a count of countries in the data, and save to countries_keyed
  // 2) coerce string valence into intenger
  // 3) generate list of strengths _actually in use_ in the data
  var countries_keyed = calcCountryKeys(data);
  var strengthlist = [];
  var max_count = 0;
  data.forEach(function(d){
    // transform string valence into intenger
    d.valence = +d.valence;
    // generate list of strengths present in the data
    strengthlist.push(d.evidencetype); 
  });

  // Post-processing:
  // - sort and remove duplicates, then generate select options
  strengthlist = _.without(_.uniq(strengthlist.sort()), "");

  // set up a scale for the map circles
  // first get max count by country
  var max = 0;
  Object.keys(countries_keyed).forEach(function(c) {
    if (countries_keyed[c].count > max) max = countries_keyed[c].count;
  });
  var cmin = CONFIG.circleareas["min"] * 1000000;
  var cmax = CONFIG.circleareas["max"] * 1000000;
  CONFIG.circleScale = d3.scaleSqrt().domain([1, max]).range([cmin,cmax]);

  // Dynamically create column markup
  // this allows variable numbers of columns, though probably not gonna be great to have less than 2 or more than 4 
  createColumnMarkup();
  colorColumns();

  // Data prep all done!
  // call our dispatch events with `this` context, and corresponding data
  CONFIG.dispatch.call("load", this, {stengths: strengthlist, countries_keyed: countries_keyed, data: data}); 
  CONFIG.dispatch.call("statechange", this, data);
  // finally, fit the map to bounds one time, this will always be the extent, despite state changes
  // note: cannot fit bounds to circles for some reason, so we fit to points instead
  CONFIG.initBounds = CONFIG.points.getBounds();
  CONFIG.map.fitBounds(CONFIG.initBounds);
}

// D3 has a dispatch patter which we use here. These dispatch functions are registered below, and called in various places throughout
function initD3DispatchFunctions() {  
  // add a load listener to populate some of the markup for headers, descriptive text, etc. 
  CONFIG.dispatch.on("load.setup", function(){
    // add the theme title to each theme column
    // and also add the descriptive "summary words" for each theme
    var themes = Object.keys(DATA.lookup.themes);
    themes.forEach(function(theme_id) {
      var col = DATA.lookup["themes"][theme_id].col;
      // add theme titles in top cols
      var title = DATA.lookup["themes"][theme_id].name;
      $(`div.title-cell[data-col='${col}']`).text(title);

      // add summary text to top cells
      var summary = DATA.lookup["themes"][theme_id].summary;
      $(`div.text-cell[data-col='${col}']`).text(summary);
   
      // add theme titles in bottom cols
      $(`div.subtitle-cell[data-col='${col}'] span.subtitle`).text(title);

    });

    // add the strategy image src, strategy title and subtitle to the top-card
    $('div#top-card div.top-card-image img').attr({'src': DATA.lookup["strategies"][CONFIG.strategy].image_src});
    $('div#top-card div.top-card-title h3.card-title').text(DATA.lookup["strategies"][CONFIG.strategy].fullscreentitle);
    $('div#top-card div.top-card-title p.card-text').text(DATA.lookup["strategies"][CONFIG.strategy].fullscreensubtitle);

    // add the description/explanatory text next to the legend
    $('div.description-container div').html(DATA.lookup["strategies"][CONFIG.strategy].description);

    // add text to the legend
    // up to now, we've always had three text items in the legend. 
    // first, squash them together in an array, then append
    var legenddata = [];
    legenddata.push(DATA.lookup["strategies"][CONFIG.strategy].legendtext1);
    legenddata.push(DATA.lookup["strategies"][CONFIG.strategy].legendtext2);
    legenddata.push(DATA.lookup["strategies"][CONFIG.strategy].legendtext3);
    var legends = d3.selectAll("td.legend-text").data(legenddata);
    legends.selectAll("span")
      .data(function(d) {return [d]})
      .enter()
      .append("span")
      .text(function(d) {return d});
  })

  // register a listener for "load" and create dropdowns for various fiters
  CONFIG.dispatch.on("load.dropdowns", function(options) {
    // get countries names from countries_keyed
    var countries = _.map(options["countries_keyed"], function(c) {return c});
    countries = _.sortBy(countries,"name");

    // COUNTRY FILTER
    // hack in a placeholder 
    countries.unshift({name:'', fips:''});
    var select = d3.select("select#country");
    // append options to select dropdown
    select.selectAll("option")
        .data(countries)
      .enter().append("option")
        .attr("value", function(d) { return d.fips.trim(); })
        .text(function(d) { return d.name.trim(); });

    // EVIDENCE FILTER
    var strengths = options["stengths"].reverse();
    strengths.unshift("");
    var select = d3.select("select#evidence");
    // append strengthoptions to select dropdown
    select.selectAll("option")
        .data(strengths)
      .enter().append("option")
        .attr("value", function(d) { return d; })
        .text(function(d) { return d != "" ? DATA.lookup["evidencetypes"][d].name : ""; });

    // SORT OPTIONS
    // Defined directly in html as <options>, vals and text

    // hack: style the dropdowns using Select2, then show
    $("select").each(function() {
      var select = $(this);
      select.select2({
        placeholder: select.attr("placeholder"),
        minimumResultsForSearch: Infinity,
        allowClear: true
      }).show();
    });
    // because we're using select2, and these options are added dynamically, 
    // we have to use event delegation to listen for changes
    delegate_event("select#country");
    delegate_event("select#evidence");
    delegate_event("select#sort");
  }); // load.menu


  // register a callback to be invoked which updates the chart when "statechange" occurs
  // apply a number of conditional filters and sorts here that determine what data is shown
  // -- filter raw data by country and type of evidence (but not the first, summary row)
  // -- sort by strength of evidence (but always keep the summary row on top)
  // -- toggle show/hide the "details" (everything row but the top row)
  // by their nature these filters have to be applied at different points in the function, which is a bit messy
  CONFIG.dispatch.on("statechange.charts", function() {
    // turn off any open tooltips, as the position will no longer correspond to a square
    closeVariableInfoTip();
    closeSquareTooltip();
    clearSquares();

    // filter the raw data given current selections
    var filtered = apply_options(DATA.rawdata);
    
    // set up the data structures for the chart data itself
    // nest data by the two main groups (theme, variable)
    // data by theme is shown in the first "row" of each column, under "ALL FINDINGS"
    // data by variable is shown in rows after that
    // Note: we don't filter or sort the top row, ever, this just gets the full DATA.rawdata for that theme

    // this results in a nested structure by cols and rows, somewhat like:
    // 
    //     col        col       col
    // ----------|----------|----------
    //   toprow  |  toprow  |  toprow
    // ----------|----------|----------
    //  otherrow | otherrow | otherrow
    // ----------|----------|----------
    //  otherrow | otherrow | otherrow
    // 

    var top_rows = d3.nest()
      // top level key is the column, sorted ascending
      .key(function(d) { return DATA.lookup["themes"][d["theme"]].col })
        .sortKeys(d3.ascending)
      // second level, a placeholder indicating that this is the toprow data
      .key(function(d) { return "toprow" })
      // third level key is the valence, sort reversed so we have plus, neutral, minus
      .key(function(d) { if (d.valence > -1) { if (d.valence == 0) {return 'neutral'; } return 'plus'; } return 'minus'; })
        .sortKeys(d3.descending)
      .entries(DATA.rawdata);

    // set up a sort function for the "other rows", if there is a sort field
    var sortoption = d3.select("select#sort").node().value
    if (sortoption) {
      // set up a custom sort function, with optional order
      var sortoptions = sortoption.split("#");
      var sortfield = sortoptions[0]; 
      var reverse = typeof sortoptions[1] === "undefined" ? 1 : -1;
      var sort_function = function(a, b) {
        var lookup_key_a = "variable_" + a;
        var lookup_key_b = "variable_" + b;
        var x = CONFIG["offsets"][lookup_key_a][sortfield];
        var y = CONFIG["offsets"][lookup_key_b][sortfield];
        if (x < y) return -1 * reverse;
        if (x > y) return 1 * reverse;
        return 0;
      };

    } else {
      // the default: simple alphpabetical sort by variable name
      var sort_function = function(a, b) {
        var x = DATA.lookup["variables"][a]["name"]; 
        var y = DATA.lookup["variables"][b]["name"]; 
        if (x < y) return -1;
        if (y < x) return 1; 
        return 0;
      }
    }

    // nest and sort the "other rows" 
    var other_rows = d3.nest()
      // top level key is the column, sorted ascending
      .key(function(d) { return DATA.lookup["themes"][d["theme"]].col })
        .sortKeys(d3.ascending)
      // second level key is the variable, sorted alphabetically (default) or according to the selected sort option
      .key(function(d) { return d["variable"] })
        .sortKeys(sort_function)
      // third level key is the valence, sort reversed so we have plus, neutral, minus
      .key(function(d) { if (d.valence > -1) { if (d.valence == 0) {return 'neutral'; } return 'plus'; } return 'minus'; })
        .sortKeys(d3.descending)
      .entries(filtered);

    // now send off data to the chart renderer, one col at a time
    // set initial column width
    CONFIG["offsets"]["colwidth"] = $(".chartcol").width();

    // first the top row, for each col
    top_rows.forEach(function(col, i){
      // - calculate total width and height of the chart
      // - select the container, and give it an explicit height
      // - then draw
      var colheight = calcOffsets(col.values,true);
      var container = d3.select("div.chartcol[data-col='" + col.key + "'] div.toprow-container").style("height", colheight + "px");
      drawChart(col.values, container, true);      
    });

    // check for "no data" condition in columns: 
    // when there is a top row but the corresponding 'other_row' has been filtered out, add a special no-data message
    if (top_rows.length != other_rows.length) {
      // figure out which one(s) is missing
      var top_keys = top_rows.map(function(d) {return d.key});      
      var other_keys = other_rows.map(function(d) {return d.key});
      var difference = top_keys.filter(x => !other_keys.includes(x));
      difference.forEach(function(key) {
        other_rows.push({key: key, values: [
            {key: "nodata", values:[{key: "nodata", values:[{nodatarows: 0, theme: "nothing"}]}]}
          ]});          
      });
      // sort so the cols stay in the same order as top row cols
      other_rows = _.sortBy(other_rows, "key");
    }
      
    // then the other rows, one col at a time
    other_rows.forEach(function(col, i) {
      // - calculate total width and height of the chart
      // - select the container, and give it an explicit height
      // - then draw
      var colheight = calcOffsets(col.values,false);
      var container = d3.select("div.chartcol[data-col='" + col.key + "'] div.otherrows-container").style("height", colheight + "px" );

      drawChart(col.values, container);
    });

    // in the current setup, where we calcOffsets() one at a time for cols, there is no easy a-priori way
    // to guage pixel perfect width of the colored top-row, as the cols themselves are percents, and will adjust
    // width slighly, and automatically, if/when there is a vertical scroll-bar present
    // to work around this, check at the end, and adjust as needed
    resizeTopRow();

    // draw the map 
    var countries_keyed = calcCountryKeys(filtered);
    drawMap(countries_keyed);

    // final step: draw up the list of publications
    listPublications(filtered);
  });

  // 
  // Initial map setup after data load
  //
  CONFIG.dispatch.on("load.map", function(data) {
    // set the map width from CONFIG
    document.getElementById('map').style.height = CONFIG["map_height"] + "px";

    // init the map with some basic settings
    CONFIG.map = L.map('map',{
      minZoom: CONFIG.minzoom,
      maxZoom: CONFIG.maxzoom,
      keyboard: false,
      scrollWheelZoom: false,
      attributionControl: false,
    });
    // add a positron basemap, without labels
    var positron = L.tileLayer('https://cartodb-basemaps-{s}.global.ssl.fastly.net/light_nolabels/{z}/{x}/{y}.png', {
      attribution: '©OpenStreetMap, ©CartoDB'
    }).addTo(CONFIG.map);

    // then create a tile pane for the labels, and add positron labels to it (only at high zoom)
    CONFIG.map.createPane('labels');
    CONFIG.map.getPane('labels').style.zIndex = 650;
    CONFIG.map.getPane('labels').style.pointerEvents = 'none';
    L.tileLayer('https://cartodb-basemaps-{s}.global.ssl.fastly.net/light_only_labels/{z}/{x}/{y}.png', {
      pane: 'labels'
    });

    new L.controlCredits({
        image: '../static/images/greeninfo.png',
        link: 'https://www.greeninfo.org/',
        text: 'Interactive mapping<br/>by GreenInfo Network'
    }).addTo(CONFIG.map);

    var attribution = L.control.attribution({
        position: 'bottomright',
    }).addTo(CONFIG.map);

    // create feature groups for circles and points and add them to the map
    CONFIG.circles = L.featureGroup().addTo(CONFIG.map);
    CONFIG.points = L.featureGroup().addTo(CONFIG.map);

  }); // load.map
} // initD3DispatchFunctions()

//
// Main map redraw function
//
function drawMap(countries_keyed) {
  // first clear any existing layers
  CONFIG.circles.clearLayers();
  CONFIG.points.clearLayers();

  // add div icons to the map for each distinct country where count > 1
  // count is the number of studies in that country in the raw data 
  var countries = Object.keys(countries_keyed);
  // sort countries by count, to ensure smaller ones are stacked on top of larger ones
  countries.sort(function(a,b) {
    return countries_keyed[b].count - countries_keyed[a].count
  });
  // go over countries, and make circles. 
  // Before we start figure out what style to use
  countries.forEach(function(name){
    // skip countries that don't have matching name, counts, lat/lngs, etc.
    if (countries_keyed[name] === undefined) return;
    if (countries_keyed[name].count === undefined || countries_keyed[name].count == 0) return;
    if (countries_keyed[name].latitude === undefined || countries_keyed[name].longitude === undefined) return;
    if (countries_keyed[name].latitude === "" || countries_keyed[name].longitude === "") return;
    if (countries_keyed[name].count > 0) {
      var country = countries_keyed[name];
      // can't fit bound to L.cicles for some reason, so we make null marker icons instead
      var nullicon = L.divIcon({ className: 'null-icon'});
      var point = L.marker([country.latitude, country.longitude], {icon: nullicon, interactive: false});
      point.addTo(CONFIG.points);
      // get an area from scale function, calc the radius, and then add the circles      
      var area = CONFIG.circleScale(country.count);
      var radius = Math.sqrt(area/Math.PI);
      var circle = L.circle([country.latitude, country.longitude], {radius: radius}).setStyle(CONFIG.defaultStyle).addTo(CONFIG.circles);
      // add interactivity
      circle.data = country;
      var plural = country.count > 1 ? "s" : "";
      circle.bindPopup(country.name + ": " + country.count + " data point" + plural);
      circle.on('click',function(e) { 
        CONFIG.map.closePopup();
        clearCircles();
        clearSquares();
        clickCircle(e.target.data, this); 
      });
      circle.on('mouseover', function (e) {
        // first clear any selections selected by other means, and other open stuff
        clearCircles();
        clearSquares();
        closeVariableInfoTip();
        this.openPopup();
        this.setStyle(CONFIG.selectedStyle);
        selectSquares({key: "fips", value: e.target.data.fips});
      });
      circle.on('mouseout', function (e) {
        // close map popups (but not on mobile)
        if (! isMobile() ) CONFIG.map.closePopup();
        // clear style, clear squares, close tooltip
        this.setStyle(CONFIG.defaultStyle);
        clearSquares();
        closeSquareTooltip();
      });
    }

    // on mobile only, pan the map to the selected place(s)
    if (isMobile() ) { CONFIG.map.panTo(CONFIG.points.getBounds().getCenter());} 

  });
}

//
// Main chart redraw function
//
function drawChart(data, container, toprow=false) {
  // bind our new piece of data to our container element
  // could also do `container.data([data.values]);`
  container.datum(data);  

  // 
  // ROWS
  //
  // create row groups for each data grouping (the top level of nest())
  var rows = container.selectAll("div.chartrow")
    .data(function(d,i) { return d; }, function(d) {return d.key});

  // remove old rows
  rows.exit().remove();

  // define row functions
  var rowheight = function(d, i) {
    var pad = toprow ? CONFIG["offsets"]["toprowpad"] : 0;
    var key = toprow ? "toprow" : "variable_" + d.key;
    return (CONFIG["offsets"][key]["totalrows"] * CONFIG["offsets"]["sqsize"]) + pad + "px";
  }

  // update existing ones left over
  rows.attr("class", "chartrow")
    .style("width",d3.select("div.toggler").style("width") )
    .style("left", 15)
    .style("top", function(d) {
      var key = d.key == "toprow" ? "toprow" : "variable_" + d.key;
      var y = CONFIG["offsets"][key]["offset_y"]; // row offset
      return y + "px";
    })
    .style("height", rowheight)

  // create new rows if our updated dataset has more than the previous
  var rowenter = rows.enter().append("div")
    .attr("class", "chartrow")
    .style("width",d3.select("div.toggler").style("width") )
    .style("left", 15)
    .style("top", function(d) {
      var key = d.key == "toprow" ? "toprow" : "variable_" + d.key;
      var y = CONFIG["offsets"][key]["offset_y"]; // row offset
      return y + "px";
    })
    .style("height", rowheight);

  //
  // TEXT LABEL WRAPPERS
  //
  var rows = container.selectAll("div.chartrow");
  var textwrappers = rows.selectAll("div.textwrapper")
    .data(function(d) {return [d]}, function(d) {return d.key});

  // exit
  textwrappers.exit().remove();

  // enter
  textwrappers.enter().append("div")
    .attr("class","textwrapper")
    .attr("class", function(d) { return d3.select(this).attr("class") + " variable-" + d.key.toLowerCase(); })
    .style("width", (CONFIG["offsets"]["textwidth"] - CONFIG["offsets"]["textpadding"] ) + "px");

  //
  // TEXT LABELS THEMSELVES
  // 
  var textwrappers = container.selectAll("div.textwrapper");
  var text = textwrappers.selectAll("div.text")
    .data(function(d) {return [d]}, function(d) {return d.key});

  // update
  text
    .classed("nothing", function(d) { return d.key == "nodata" })
    .html(function(d) {
      var text;
      if (toprow) {
        // top row gets special treatment
        text = "All findings <span class='hint toptext'> Click a square for detailed results</span>";
      } else if (d.key == "nodata") {
        // no data in rows after the top row, gets no info icon
        text = "No data to show";
      } else {
        // a normal chart row: name plus info icon
        text = "<span class='variable-text'>" + DATA.lookup["variables"][d.key]["name"] + "</span> <span onclick='showVariableInfoTip(event)' class='variable-info icon-info' data-var='" + d.key + "'></span>";
      } 
      return text;
  });

  // enter
  text.enter().append("div")
    .classed("text", true)
    .classed("nothing", function(d) { return d.key == "nodata" })
    .html(function(d) {
      var text;
      if (toprow) {
        // top row gets special treatment
        text = "All findings <span class='hint toptext'> Click a square for detailed results</span>";
      } else if (d.key == "nodata") {
        // no data, in rows after the top row, gets no info icon
        text = "No data to show";
      } else {
        // a normal chart row: name plus info icon
        text = "<span class='variable-text'>" + DATA.lookup["variables"][d.key]["name"] + "</span> <span onclick='showVariableInfoTip(event)' class='variable-info icon-info' data-var='" + d.key + "'></span>";
      } 
      return text;
    })
    .style("font-size", function() { return CONFIG["offsets"]["labelsize"] + "px"; })
    .on("click", function(d) {
      // no click behavior for the top row, and nodata rows
      if ( toprow ) return;
      if (d.key == "nodata") return;
      // for the rest of the rows, filter by this variable (or theme)
      // value is simply the data key of the clicked upon label
      var value = d.key;
      // key is dependent on hierarchy, first get the first datum; every one of these should have at least one datum or it wouldn't be on the screen
      var datum = d.values[0].values[0]; 
      if (typeof datum == "undefined") return; 
      // if the theme (e.g. "ENV") is equal to the data label of the clicked item (e.g. ENV for "environmental"), then we are filtering by "theme"
      // if not, then we are filtering by "variable" 
      // a bit more hardcoding of these category names than I would like, but I am told that the use of theme and variable will be consistent across datasets
      var key = datum["theme"] == CONFIG.selectedgroup["value"] ? "theme" : "variable"; 
      
      // if we've already selected this row, clicking again serves to "unselect" it
      var currentkey = CONFIG.selectedgroup["key"];
      var currentvalue = CONFIG.selectedgroup["value"];
      if (key == currentkey && value == currentvalue) {
        // clear the selection
        CONFIG.selectedgroup = {};
      } else {
        // new selection: update the "selectedgroup" key/value, so we can track this, and apply with other filters 
        CONFIG.selectedgroup["key"]   = key;
        CONFIG.selectedgroup["value"] = value;
      }
      // all done, dispatch!
      CONFIG.dispatch.call("statechange",this,DATA.rawdata);
    });

  // exit
  text.exit().remove();

  //
  // CHART GROUPS
  //
  // create chart groups for each of our chart categories
  // there are currently only two: plus and minus
  var rows = container.selectAll("div.chartrow");
  var charts = rows.selectAll("div.chart")
    .data(function(d) { return d.values; }, function(d) {return d.key});

  // define chartgroup functions
  var charttopfunction = function(d,i) {
    var key = d3.select(this.parentNode).datum().key;
    if (key != "toprow") key = "variable_" + key;
    var offset = 0;
    if (d.key == "neutral") offset = CONFIG["offsets"][key]["neutraloffset"];
    if (d.key == "minus") offset = CONFIG["offsets"][key]["minusoffset"];
    // top row only gets additional padding
    var pad = toprow ? CONFIG["offsets"]["toprowpad"] / 2 : 0;
    return offset + pad + "px";
  };   

  // get rid of the old ones we don't need when doing an update
  charts.exit().remove();

  // update existing ones left over
  charts.attr("class", "chart")
    .attr("class", function(d,i) { 
      var c = toprow ? " toprow" : "";      
      return d3.select(this).attr("class") + c; 
    })
    .style("top", charttopfunction) 
    .style("height",function(d) {
      if (d.values[0].theme == "nothing") return 0;
      var valence = d.key + "rows";
      var key = toprow ? "toprow" : "variable_" + d.values[0].variable;
      var rows = CONFIG["offsets"][key][valence];
      var height = (rows * CONFIG["offsets"]["sqsize"]) + "px";
      return height;
    });

  // create new ones if our updated dataset has more then the previous
  charts.enter().append("div")
    .attr("class","chart")
    .attr("class", function(d,i) { 
      var c = toprow ? " toprow" : "";      
      return d3.select(this).attr("class") + c; 
    })
    .style("left", CONFIG["offsets"]["textwidth"] + "px")
    .style("top", charttopfunction) 
    .style("height",function(d) {
      if (d.values[0].theme == "nothing") return 0;
      var valence = d.key + "rows";
      var key = toprow ? "toprow" : "variable_" + d.values[0].variable;
      var rows = CONFIG["offsets"][key][valence];
      var height = (rows * CONFIG["offsets"]["sqsize"]) + "px";
      return height;
    });

  // 
  // CHARTS: outer svg wrapper
  // 

  charts = rows.selectAll("div.chart");
  var chartcontainers = charts.selectAll("svg")
    .data(function(d) { return [d] }, function(d) { return d.key });

  // exit
  chartcontainers.exit()
    .remove();

  // update
  chartcontainers
    .attr("width", (CONFIG["offsets"]["colwidth"] - CONFIG["offsets"]["textwidth"]) + "px") 
    .attr("visibility", function(d) { return d.values[0].theme == "nothing" ? "hidden" : "visible" })
    .attr("height",function(d) {
      if (d.values[0].theme == "nothing") return 0;
      var valence = d.key + "rows";
      var key = toprow ? "toprow" : "variable_" + d.values[0].variable;
      var rows = CONFIG["offsets"][key][valence];
      var height = (rows * CONFIG["offsets"]["sqsize"]) + "px";
      return height;
    });

  // enter
  chartcontainers.enter().append("svg")
    .attr("overflow","visible")
    .classed("chartcontainer",true)
    .classed("toprow", function() { return d3.select(this).node().parentNode.classList.contains("toprow")} )
    .attr("width", function() { return (CONFIG["offsets"]["colwidth"] - CONFIG["offsets"]["textwidth"]) + "px" } )
    .attr("visibility", function(d) { return d.values[0].theme == "nothing" ? "hidden" : "visible" })
    .attr("height",function(d) {
      if (d.values[0].theme == "nothing") return 0;
      var valence = d.key + "rows";
      var key = toprow ? "toprow" : "variable_" + d.values[0].variable;
      var rows = CONFIG["offsets"][key][valence];
      var height = (rows * CONFIG["offsets"]["sqsize"]) + "px";
      return height;
    });

  //
  // SQUARES: sort and bind data
  //

  // reselect the chart groups, so that we get any new ones that were made
  // our previous selection would not contain them
  charts = rows.selectAll("svg");
  var squares = charts.selectAll("rect")
    // sort data by valence and type
    .data(function(d) { return _.sortBy(d.values,"valence","evidencetype") }, function(d) {return d.publication_id});

  // get rid of ones we don't need anymore
  squares.exit()
    .remove();

  // update existing squares
  squares
      .classed("neutral",function(d) { return d.valence == 0 })
      // d.valence: this determines the square color
      .classed("plus",function(d) { return d.valence > 0 })
      .classed("minus",function(d) { return d.valence < 0 })
      // d.evidencetype: this is the type of evidence, and determines the square opacity
      // the map from d.evidencetype to "light" or "dark" is defined in the lookup
      .classed("light", function(d) { return typeof d.evidencetype === "undefined" ? false : DATA.lookup["evidencetypes"][d.evidencetype]["opacity"] == "light"})
      .classed("dark", function(d) { return typeof d.evidencetype === "undefined" ? false : DATA.lookup["evidencetypes"][d.evidencetype]["opacity"] == "dark"})
      .attr("width", CONFIG["offsets"]["sqsize"] - 1)
      .attr("height", CONFIG["offsets"]["sqsize"] - 1)
      .on("click", clickSquare);

  if (!toprow) {
    squares.transition()
      .duration(250)
        .attr("x", positionSquareX)
        .attr("y", positionSquareY);
  } else {
    squares
        .attr("x", positionSquareX)
        .attr("y", positionSquareY);
  }

  // make new squares
  var sqenter = squares.enter()
    .append("rect")
    // .classed("toprow", function() { return d3.select(this).node().parentNode.classList.contains("toprow")} )
    .classed("neutral",function(d) { return d.valence == 0 })
    // d.valence: this determines the square color
    .classed("plus",function(d) { return d.valence > 0 })
    .classed("minus",function(d) { return d.valence < 0 })
    // d.evidencetype: this is the type of evidence, and determines the square opacity
    // the map from d.evidencetype to "light" or "dark" is defined in the lookup
    .classed("light", function(d) { return typeof d.evidencetype === "undefined" ? false : DATA.lookup["evidencetypes"][d.evidencetype]["opacity"] == "light"})
    .classed("dark", function(d) { return typeof d.evidencetype === "undefined" ? false : DATA.lookup["evidencetypes"][d.evidencetype]["opacity"] == "dark"})
    .attr("width", CONFIG["offsets"]["sqsize"] - 1)
    .attr("height", CONFIG["offsets"]["sqsize"] - 1)
    .on("click", clickSquare);

  if (!toprow) {
    sqenter.transition()
      .duration(250)
        .attr("x", positionSquareX)
        .attr("y", positionSquareY);
  } else {
    sqenter
        .attr("x", positionSquareX)
        .attr("y", positionSquareY);
  }

} // end drawChart()

//
// NAMED FUNCTIONS
//
function positionSquareX(d, i) {
  var x = calcx(i, CONFIG["offsets"]["number_that_fit"], CONFIG["offsets"]["sqsize"]);
  return x;
}

function positionSquareY(d, i) {
  var y = calcy(i, CONFIG["offsets"]["number_that_fit"], CONFIG["offsets"]["sqsize"]);
  return y;
}

// define behavior when clicking a map circle
function clickCircle(markerdata, clicked) {
  // simply trigger change on the counry select, which offers some nice side benefits:
  // other filters are applied, and the dropdown state mirrors map state
  $("select#country").val(markerdata.fips).trigger("change");

  // then simply update the icons
  $("div.country-circle").removeClass("selected");
  $(event.target).parent().addClass("selected");
  
  // openPopup() on the resulting layer
  CONFIG.circles.eachLayer(function(layer) {
    if (layer.data.fips == markerdata.fips) {
      layer.openPopup();
      return;
    }
  });
}

// define behavior when clicking a chart square
function clickSquare(d) {
  // first, clear any selected squares and circles
  clearCircles();
  clearSquares();
  closeVariableInfoTip();

  // add selected style to this square, and the ones in adjacent charts
  selectSquares({key: "finding_id", value: d.finding_id});

  // select the matching publication
  selectPublication(d.publication_id);

  // add tooltip content and display it
  var link = CONFIG.tooltip.select("a.tooltip-author-link");
  link.text(DATA.lookup['publications'][d.publication_id].author);
  link.attr("href", DATA.lookup['publications'][d.publication_id].url);
  link.attr("target", "_blank");
  var conclusion = d.conclusion == "" ? "" : ": " + d.conclusion;
  CONFIG.tooltip.select("span.tooltip-conclusion").html(conclusion);
  CONFIG.tooltip.style("display","block");
  // position the tooltip, but if we dragged it somewhere, leave it alone
  if (!CONFIG.tooltip_dragged) {
    var tip_width = CONFIG.tooltip.node().offsetWidth;
    var tip_height = CONFIG.tooltip.node().offsetHeight;
    var win_width = $(window).width();
    var win_height = $(window).height();
    var pos = getScreenBBox(this);
    var xpos = pos.e.x - (tip_width / 2);
    if (xpos > win_width - tip_width) {
      xpos = pos.e.x - tip_width; 
    }
    var ypos = pos.e.y + 20;
    if (ypos > win_height - tip_height) {
      ypos = pos.e.y - tip_height - 20;
    }

    CONFIG.tooltip
      .style("left",xpos + "px")
      .style("top",ypos + "px");
  }

  // update the map marker that contains this study
  selectCircle(d.fips);
}

// Returns an Object {n, s, e, w, nw, sw, ne, se}
// from d3.tip
function getScreenBBox(target) {
  var targetel   = target || d3.event.target,
      bbox       = {},
      matrix     = targetel.getScreenCTM(),
      tbbox      = targetel.getBBox(),
      width      = tbbox.width,
      height     = tbbox.height,
      x          = tbbox.x,
      y          = tbbox.y,
      scrollTop  = document.documentElement.scrollTop || document.body.scrollTop,
      scrollLeft = document.documentElement.scrollLeft || document.body.scrollLeft;

  var svg = getSVGNode(target);
  var point = svg.createSVGPoint();

  point.x = x + scrollLeft;
  point.y = y + scrollTop;
  bbox.nw = point.matrixTransform(matrix);
  point.x += width;
  bbox.ne = point.matrixTransform(matrix);
  point.y += height;
  bbox.se = point.matrixTransform(matrix);
  point.x -= width;
  bbox.sw = point.matrixTransform(matrix);
  point.y -= height / 2;
  bbox.w  = point.matrixTransform(matrix);
  point.x += width;
  bbox.e = point.matrixTransform(matrix);
  point.x -= width / 2;
  point.y -= height / 2;
  bbox.n = point.matrixTransform(matrix);
  point.y += height;
  bbox.s = point.matrixTransform(matrix);

  return bbox;
}

// from d3.tip
function getSVGNode(el) {
  if (el.tagName.toLowerCase() == 'svg') return el
  return el.ownerSVGElement
}

// resize everything
function resizePage() {
  // seems iOs scroll is triggering a resize for some reason
  // so only continue if the window has in fact changed size
  var newsize = $(window).width();
  if (newsize == CONFIG.cachedwidth) return;

  // first, recalc offets for all groups, and trigger a statechange
  CONFIG.dispatch.call("statechange",this,DATA.rawdata);

  // then, resize the chart containers
  // only needed here if not included in "Statechange"
  resizeContainers();
}

// resize all the containers listed below from CONFIG
function resizeContainers() {
  d3.select(".bottom").style("height", CONFIG["height"] + "px"); 
}

function resizeTopRow() {
  // Occassionally, width calc's in top row are out of sync with toggler bar above 
  // (due to pres/abs of scroll bar, to which the % width cols adjust, but our absolutely sized chart rows)
  // the following seems to fix it 
  setTimeout(function() {
    // compare the two offending elements
    var toprow = $("div.toprow-container div.chartrow");
    var togglewidth = $("div.toggler").width();
    var toprowwidth = toprow.width();
    // because of sub-pixel measures, see if the abs difference is greater than 1
    // and if so, give em a resize
    // this will likely throw a "too late" error because of transition collision, but that's less offensive than misaligned elements
    var diff = Math.abs(togglewidth - toprowwidth);
    if ( diff > 1 ) toprow.width(togglewidth); 
  }, 150);
}

// Generic function to nest data on selected group, then either "plus" or "minus",
//   depending on value of "valence"
function nest(data, group) { 
  var nested = d3.nest()
    .key(function(d) { return d[group] })
    .key(function(d) { if (d.valence > -1) { if (d.valence == 0) {return 'neutral'; } return 'plus'; } return 'minus'; }).sortKeys(d3.descending)
    .entries(data);

  return nested;
} // nest

// Filter flat (not nested) data based on a key and a value
function filter(data, key, value) {
  var filtered = data.filter(function(d) {
    // country FIPS requires more extensive filtering:
    // FIPS can be a list, or a single country 
    var match;
    if (key == "fips") {
      var list = d["fips"].split(",");
      list.forEach(function(item) {
        if (item.trim() == value) {
          match = true;
          return;
        }
      });
    } else {
      match = (d[key] == value);
    }
    return match;
  });
  return filtered;
}

function delegate_event(selected) {
  // use event delegation to dispatch change function from select2 options
  $("div.row#filters").on("change", selected, function(e) {
    e.stopPropagation();
    CONFIG.dispatch.call("statechange",this,DATA.rawdata);
  });
}

// to support a variable number of columns (per theme), we dynamically create the column markup at run-time
function createColumnMarkup() {
  // first the top row of "buttons"
  var target = $("div#button-container");
  var row = $("<div>", {"class": "row"});
  target.append(row);
  Object.keys(DATA.lookup.themes).forEach(function(theme, i) {
    var wrapper = $("<div>", {"class": "col-md button-wrapper"});
    row.append(wrapper);

    var header = $("<div>", {"class": `btn-header btn-col btn-col-${i + 1} table-div`});
    wrapper.append(header);

    // append the theme titles
    var title = $("<div>", {"class": "title-cell"});
    title.attr({"data-col": i + 1});
    header.append(title);

    // append the theme conclusions
    var text = $("<div>", {"class": "text-cell"});
    text.attr({"data-col": i + 1});
    header.append(text);
  });

  // now the markup for the chart columns
  var target = $("div.chart-container");
  var row = $("<div>", {"class": "row"});
  target.append(row);
  Object.keys(DATA.lookup.themes).forEach(function(theme, i) {
    var wrapper = $("<div>", {"class": "col-md chartcol"});
    wrapper.attr({"data-col": i + 1});
    row.append(wrapper);

    var toggler = $("<div>", {"class": "toggler"});
    toggler.attr({
      "data-col": i + 1,
      "data-details": "show",
      "onclick": "event.stopPropagation(); toggleColumnDetails(event);" 
    });
    wrapper.append(toggler);

    var header = $("<div>", {"class": `btn-bottom-header btn-col btn-col-${i + 1} table-div`});
    toggler.append(header);

    var subtitle = $("<div>", {"class": "subtitle-cell"});
    subtitle.attr({"data-col": i + 1});
    header.append(subtitle);

    var span = $("<span>", {"class": "subtitle"});
    subtitle.append(span);

    var details = $("<div>", {"class": "details"});
    subtitle.append(details);

    var span_details = $("<span>", {"class": "details-msg"});
    span_details.html("less detail <i class='fa fa-chevron-up'></i>");
    details.append(span_details);

    var span_details2 = $("<span>", {"class": "details-msg", "style": "display:none;"});
    span_details2.html("more detail <i class='fa fa-chevron-down'></i>");
    details.append(span_details2);

    var top = $("<div>", {"class": "toprow-container"});
    wrapper.append(top);

    var other = $("<div>", {"class": "otherrows-container"});
    wrapper.append(other);

  });
}

// Colors: for existing strategies, keep the colors as defined in CSS (and in the original articles)
// for new strategies, pull from color-brewer "Paired" colors defined in CONFIG.col-colors
// not very dynamic, but will have to do for now
function colorColumns() {
  if (CONFIG.strategy > 5) {
    $('div.btn-header').each(function(i) {
      $(this).css({'background-color': CONFIG['col-colors'][i]})
    });
    $('div.btn-bottom-header').each(function(i) {
      $(this).css({'background-color': CONFIG['col-colors'][i]})
    });
  }
}

// Publications. Simply add them to the bottom, from a list
// Also, update a count box, below the legend
function listPublications(data) {
  // first, get only a unique set of the matching pubs from the full list of publications
  var pubids = [...new Set(data.map(item => item.publication_id))];
  var publist = {};
  pubids.forEach(function(pid) {
    publist[pid] = DATA.lookup.publications[pid];
  })

  // now sort the list by author, and add them to the dom
  var target = $("div.publications-wrapper div.publications").empty();
  var lookup = _.sortBy(publist, "author");
  var keys = Object.keys(lookup);
  keys.forEach(function(pub_id) {
    var wrapper = $("<div>", {
      "class": "pub-entry",
      "data-pubid": lookup[pub_id].pub_id,
    }).appendTo(target);
    var markup = `<span class="author">${lookup[pub_id].author}</span>. `;
    markup += `<span class="title"><a href="${lookup[pub_id].url}" target="_blank">${lookup[pub_id].name}</a></span> `
    var entry = $("<div>", {
      html: markup,
    }).appendTo(wrapper);

    // clicking one of these, selects the squares
    wrapper.on("click", function() {
      clearSquares(); // clear existing selected squares
      closeSquareTooltip(); // close any open tooltips
      $("div.pub-entry").removeClass("pub-selected"); // can only select one at a time
      var target = $(this);
      target.toggleClass("pub-selected");
      selectSquares({key: "publication_id", value: parseInt(target.data().pubid)});
    });
  });

  // update a box next to the map that shows the total number of publications
  var studycount = Object.keys(DATA.lookup.publications).length;
  $('div#study-count #details').text(studycount);
}

// given flattened data, key an object by country, with counts and other salient details
// used by the map and for constructing select#country <options>
function calcCountryKeys(data) {
  // more work to do if we want to filter this by a single country
  // becuase country can be a list, count will be incremented for other countries in that list 
  // unless we trap that here
  var countryoption = d3.select("select#country").node().value;

  var result = {};
  data.forEach(function(d) {
    // d.country can be a list of countries, so check for that, and split if so
    var names = d.fips.indexOf(",") ? d.fips.split(",") : [d.fips];
    names.forEach(function(fips){
      // trim whitespace
      if (fips == "") return;
      fips = fips.trim();
      
      // when country option is set, return if the fips doesn't match 
      if (countryoption && fips != countryoption) return;

      // first time here, we need to set count to 0
      if (typeof result[fips] === "undefined") result[fips] = {"count": 0};
      result[fips]["count"] += 1;
      result[fips]["name"] = DATA.lookup["countries"][fips]["name"];
      result[fips]["fips"] = fips;
      result[fips]["latitude"] = DATA.lookup["countries"][fips]["latitude"];
      result[fips]["longitude"] = DATA.lookup["countries"][fips]["longitude"];
    });    
  });
  return result;
}

// Iterate through data in order to calc:
// - overall chart and column area width and height
// - row offsets (spacing between rows)
// - chart offset, for spacing between plus, neutral, minus rows
function calcOffsets(data, toprow=false) {
  // placeholder, for the data iteration, below
  var nextoffset = 0;
  // some initial settings 
  CONFIG["offsets"]["chartrows"] = 0; // the actual chart rows (plus and minus)
  CONFIG["offsets"]["grouprows"] = data.length - 1; // the named theme rows for this group

  // set some names for convenience
  var sqsize = CONFIG["offsets"]["sqsize"];
  var number_that_fit = 0;

  // loop through the chart data to get an initial layout of chart rows,
  // and importantly, a total height in one column
  data.forEach(function(d,i) {
    // Add an empty object for this group, e.g. config.offsets.theme_id
    var key = d.key == "toprow" ? "toprow" : "variable_" + d.key;
    CONFIG["offsets"][key] = {};

    // Set the current "y" offset, will be zero when i = 0
    CONFIG["offsets"][key]["offset_y"] = nextoffset;

    // Now calc the next one, for the next iteration
    // first look through values and get sums for plus and minus
    var plus = 0;
    var minus = 0;
    var neutral = 0;
    d.values.forEach(function(d) {
      if (d.key == "plus") plus = d.values.length;
      if (d.key == "minus") minus = d.values.length;
      if (d.key == "neutral") neutral = d.values.length;
    });

    // from these counts, figure out how many rows this takes
    number_that_fit = Math.floor( (CONFIG["offsets"]["colwidth"] - CONFIG["offsets"]["textwidth"]) / (sqsize + 1) );
    var plusrows = Math.ceil(plus / number_that_fit);
    var minusrows = Math.ceil(minus / number_that_fit);
    var neutralrows = Math.ceil(neutral / number_that_fit);
    var totalrows = plusrows + minusrows + neutralrows;

    // save this for use when rendering
    CONFIG["offsets"][key]["totalrows"] = totalrows; 
    CONFIG["offsets"][key]["plusrows"]  = plusrows; 
    CONFIG["offsets"][key]["minusrows"] = minusrows; 
    CONFIG["offsets"][key]["neutralrows"] = neutralrows; 

    // calc chart offsets for the minus chart, for this one row
    // this is based on the total count of plus rows, considering overflow
    CONFIG["offsets"][key]["neutraloffset"] = plusrows * sqsize;
    CONFIG["offsets"][key]["minusoffset"] = (plusrows * sqsize) + (neutralrows * sqsize);

    // Next, calc the row offset: rows * the height of one square, plus the bottom margin
    var pad = toprow ? CONFIG["offsets"]["toprowpad"] : 0; // Top row (only) has some padding, so lets add that to row 1
    nextoffset = nextoffset + (totalrows * sqsize) + CONFIG["offsets"]["rowpadding"] + pad;

    // add plus/minus counts at this level (to facilitate sorting)
    CONFIG["offsets"][key]["pluscount"] = plus;
    CONFIG["offsets"][key]["minuscount"] = minus;
    CONFIG["offsets"][key]["neutralcount"] = neutral;
    CONFIG["offsets"][key]["totalcount"] = plus + minus + neutral;

    // keep a count of rows, from which to calculate total height
    CONFIG["offsets"]["chartrows"] += totalrows; 
  });
  // all done, add some calcs based on the sums we've just done
  CONFIG["offsets"]["number_that_fit"] = number_that_fit
  var charts_height      = CONFIG["offsets"]["chartrows"] * sqsize;
  var pad_height         = CONFIG["offsets"]["rowpadding"] * CONFIG["offsets"]["grouprows"];
  var toppad             = CONFIG["offsets"]["toprowpad"];
  var single_col_height  = (charts_height + pad_height + toppad);

  // we'll use this to give an explicity height to the cols
  return single_col_height;
}

// calc x position of rectangles, given container width, and square size
function calcx(i, number_that_fit, sqsize) {
  // scale i per row width, so that the count is based in terms of row width, 
  // not a continous linear scale. This makes 13 into 3, 17 into 2, etc. 
  i = scale_count_per_range(i, number_that_fit);

  // now compare our position to the number that fit to get an offset
  var rawx = i + 1 > number_that_fit ? i - number_that_fit : i;
  var x = rawx * sqsize;
  return x; 
}

// calc y position of rectangles, given container width, and square size
function calcy(i,number_that_fit, sqsize) {
  var this_row = Math.floor(i / number_that_fit);
  var y = this_row * sqsize;
  return y;
}

// scale i per row width, so that the count is based in terms of row width, 
// not a continous linear scale. This makes 13 into 3, 17 into 2, etc. 
function scale_count_per_range(i, number) {
  var row = Math.floor( i / number );
  i = i - (row * number);
  return i;
}

// apply these options to filter the flat (not nested) data, in sequence
function apply_options(data) { 
  // apply country filter, if there is one
  var countryoption = d3.select("select#country").node().value;
  if (countryoption) {
    data = filter(data, "fips", countryoption);
  }

  // apply evidence filter, if there is one
  var evidenceoption = d3.select("select#evidence").node().value;
  if (evidenceoption) data = filter(data, "evidencetype", evidenceoption);

  // apply group selection, if there is one
  if (typeof CONFIG.selectedgroup.key !== "undefined") data = filter(data, CONFIG.selectedgroup.key, CONFIG.selectedgroup.value) 

  return data;
}

// clear all selections and filters, essentially reset the app state without a refresh
function clear_all() {
  // clear the vis (map will clear with change, below)
  clearSquares();
  closeSquareTooltip();
  closeVariableInfoTip();

  // clear any group selection
  CONFIG.selectedgroup = {};

  // reset the selects
  $('select#country').val('').trigger('change');  
  $('select#evidence').val('').trigger('change');  
  $('select#sort').val('').trigger('change');  

  // reset the map view
  CONFIG.map.fitBounds(CONFIG.initBounds);
}

// select a country circle or circles, given a fips code or comma-separated list of fips
function selectCircle(fips) {
  // fips could be a list of countries, or could be a single country, so first devolve
  var fipslist = fips.indexOf(",") > -1 ? fips.split(",") : [fips]; 
  fipslist.forEach(function(fipscode) {
    CONFIG.circles.eachLayer(function(layer){
      if (layer.data.fips == fipscode) {
        layer.setStyle(CONFIG.selectedStyle);
      }
    });
  })
}

// unselect all currently selected circles
function clearCircles() {
  CONFIG.circles.eachLayer(function(layer) {
    layer.setStyle(CONFIG.defaultStyle);
  })
}

// select all matching publications given a publication id
function selectPublication(pubid) {
  // remove any existing selection
  var target = $('div.pub-entry'); 
  target.removeClass('pub-selected');
  target.each(function() {
    var listing = $(this);
    if (listing.data().pubid == pubid) {
      listing.addClass('pub-selected');
    }
  });
}


// select all matching squares given a matching data attribute key and value
function selectSquares(match) {
  var key = match.key; 
  var value = match.value;

  // first delete any squares already created by selection
  // d3.selectAll("div.square.selected").remove();

  // now troll through the rect data and look for matches
  d3.selectAll("rect")
    .each(function(d) {
      var rect = d3.select(this);
      if ( typeof d === "undefined" || !d.hasOwnProperty(key) ) { return };

      // because d[key] can be an "array", test for that and handle appropriately
      // I'm not 100% sure why this is necessary, but if we don't have this, 
      // some rects are coming up without data, despite being removed from the dom, just above 
      if (isNaN(d[key])) {
        var values = d[key].indexOf(",") > -1 ? d[key].split(",") : [d[key]];
      } else {
        var values = [d[key]];
      }

      values.forEach(function(data_value) {
        if (data_value == value) {
          // draw order prevents the correct display of stroke on top of neighboring svg
          // to work around this, add an absolutely positioned div 
          var x = rect.attr("x") * 1 - 2;
          var y = rect.attr("y") * 1 - 2;
          var width = rect.attr("width") * 1 + 4;
          var height = rect.attr("height") * 1 + 4;

          var parent = rect.node().parentNode.parentNode;
          var div = document.createElement("div");
          div.style.position = "absolute";
          div.style.width = width + "px";
          div.style.height = height + "px";
          div.style.top = y + "px";
          div.style.left = x + "px";
          div.setAttribute("class","square selected");
          parent.appendChild(div);
        }
      }); 
    });
}
// and the correlary: remove selected squares completely
function clearSquares() {
  d3.selectAll("div.selected").remove();
}

// close any open "square" tooltip (not on the map, this refers only to the squares tooltips)
function closeSquareTooltip() {
  d3.selectAll("div.square-tooltip").style("display","none");
}

// show or hide chart details below the top chart
function toggleColumnDetails(e) {
  // hide or show this cols details
  var target = e.currentTarget || e.target;
  target = $(target);

  // toggle data-details
  var type = target.data('details') == 'show' ? 'hide' : 'show';
  target.data('details', type);

  // toggle the message
  target.find('span.details-msg').toggle();

  // toggle the bottom chart
  target.siblings('div.otherrows-container').toggle();
}

// show and position legend header tooltip given an id 
function showLegendTip(e, id) {
  $('div.legend-tooltip').hide().removeClass("fixed");
  var tip = $('#' + id);
  if (! isMobile() ) {
    tip.css({
      "top": e.pageY - 100,
      "left": e.pageX - 200
    });
  } else {
    tip.css({
      "top": "",
      "left": ""
    });
    tip.addClass("fixed");
  }
  tip.show();
}

function closeLegendTooltip() {
  $('div.legend-tooltip').hide();
}

// handle info-icon clicks on variable names to display a tooltip about that variable
function showVariableInfoTip(e) {
  // make sure we don't propagate to the underlying text element, which also has click behavior
  e.stopPropagation();
  
  // get the tooltip and the clicked-upon variable key
  var tip = $("div.variable-tooltip").hide().removeClass("fixed");
  var key = e.target.getAttribute('data-var');

  // update content
  $("div.variable-tooltip-content").text(DATA.lookup["variables"][key]["tooltip"]);

  // update position
  if (! isMobile() ) {
    tip.css({
      "top": e.pageY - 80,
      "left": e.pageX + 25
    });
  } else {
    tip.css({
      "top": "",
      "left": ""
    });
    tip.addClass("fixed")
  }
  tip.show();

}

// close all variable info-icon tooltips
function closeVariableInfoTip() {
  var tip = d3.select("div.variable-tooltip")
    .style("display","none")
}

// shims and utilities 
function isMobile() { return window.innerWidth < 768; }